(function () {
  var u = window.RamlystSF;
  if (!u || !u.enabled) return;
  var RB = "linear-gradient(135deg,#e5484d,#f5a524,#f5d90a,#30a46c,#0090ff,#8e4ec6)",
    TT = "linear-gradient(135deg,#efb027 50%,#cfcfc9 50%)";
  var j = {
      white: "#e8ebef", bianco: "#e8ebef", weiss: "#e8ebef", blanc: "#e8ebef", wit: "#e8ebef",
      d: "#ffffff", e: "#fbfbf8", f: "#f6f6f2", g: "#f0f0ea", h: "#ebeae2",
      i: "#e9e7dd", io: "#e9e7dd", ich: "#e9e7dd", je: "#e9e7dd", j: "#e7e4d6", k: "#e4e0cf",
      blue: "#378add", blu: "#378add", blau: "#378add", bleu: "#378add", blauw: "#378add",
      neonblau: "#2f9cff", neonblauw: "#2f9cff", tiefblau: "#1f5f8b",
      teal: "#2a8c8c", diepblauwgroen: "#2a8c8c", sarcelle: "#2a8c8c",
      yellow: "#efb027", giallo: "#efb027", gelb: "#efb027", jaune: "#efb027", geel: "#efb027", canary: "#f4d000",
      green: "#7bbf4f", verde: "#7bbf4f", verte: "#7bbf4f", grun: "#7bbf4f", vert: "#7bbf4f", groen: "#7bbf4f", groente: "#7bbf4f", olive: "#7a7b2e",
      pink: "#d4537e", rosa: "#d4537e", rose: "#d4537e", roze: "#d4537e",
      black: "#262626", nero: "#262626", schwarz: "#262626", noir: "#262626", zwart: "#262626",
      brown: "#7b5230", marrone: "#7b5230", braun: "#7b5230", marron: "#7b5230", bruin: "#7b5230", cognac: "#9a4a1d",
      chocolate: "#5a3a22", cioccolato: "#5a3a22", schokolade: "#5a3a22", chocolat: "#5a3a22", chocolade: "#5a3a22",
      champagne: "#e7c9a0", champagner: "#e7c9a0", sekt: "#e7c9a0",
      red: "#d6483b", rosso: "#d6483b", rot: "#d6483b", rouge: "#d6483b", rood: "#d6483b",
      orange: "#e07b2e", arancione: "#e07b2e", oranje: "#e07b2e",
      purple: "#7f77dd", viola: "#7f77dd", violett: "#7f77dd", violet: "#7f77dd", lila: "#7f77dd", paars: "#7f77dd",
      gray: "#9a9a93", grey: "#9a9a93", grigio: "#9a9a93", grau: "#9a9a93", gris: "#9a9a93", grijs: "#9a9a93",
      silver: "#cfcfc9", argento: "#cfcfc9", silber: "#cfcfc9", argent: "#cfcfc9", zilver: "#cfcfc9",
      burgundy: "#6d1a2b", bordeaux: "#6d1a2b", borgogna: "#6d1a2b", burgund: "#6d1a2b",
      salmon: "#f08a74", salmone: "#f08a74", lachs: "#f08a74", saumon: "#f08a74", zalm: "#f08a74",
      peach: "#f5b89a", pesca: "#f5b89a", pfirsich: "#f5b89a", pfirsichfarben: "#f5b89a", peche: "#f5b89a", perzik: "#f5b89a",
      turquoise: "#40c4c4", turchese: "#40c4c4", turkis: "#40c4c4", turkisfarbener: "#40c4c4", turkoois: "#40c4c4", turkooizen: "#40c4c4",
      ivory: "#f3ead6", avorio: "#f3ead6", elfenbein: "#f3ead6", ivoire: "#f3ead6", ivoor: "#f3ead6",
      jubilee: "#d8d3c4", giubileo: "#d8d3c4", sundust: "#d9b48c",
      rainbow: RB, arcobaleno: RB, regenbogen: RB, "arc-en-ciel": RB, regenboog: RB,
      "two tone": TT, bicolore: TT, bicolor: TT, "due toni": TT, zweifarbig: TT, tweekleurig: TT,
    },
    z = [
      [/two ?tone|due toni|zweifarbig|bicolor|tweekleurig|multi|mehrfarbig|meerkleurig| e | und | et | en | and |\//, TT],
      [/rose|rosa|roze/, "#f0997b"],
      [/yellow|giallo|gelb|jaune|geel/, "#efb027"],
      [/white|bianco|weiss|blanc|wit/, "#d6d4cb"],
      [/platin/, "#bdbcb4"],
      [/black|nero|schwarz|noir|zwart/, "#3a3a3a"],
      [/silver|argento|silber|argent|zilver|sterling/, "#cfcfc9"],
      [/steel|stainless|acciaio|edelstahl|acier|staal/, "#b7b9bd"],
      [/gold|goud|\boro\b|\bor\b/, "#efb027"],
    ];
  function nz(e) {
    var t = String(e).toLowerCase().replace(/\(.*\)/, "");
    try { t = t.normalize("NFD").replace(/[̀-ͯ]/g, ""); } catch (er) {}
    return t.replace(/ß/g, "ss").replace(/\s+/g, " ").trim();
  }
  function ie(e) {
    var t = nz(e);
    if (j[t]) return j[t];
    for (var p = t.split(/[^a-z0-9]+/), i = 0; i < p.length; i++) if (j[p[i]]) return j[p[i]];
    return "#d9d9d2";
  }
  function ne(e) {
    for (var t = nz(e), r = 0; r < z.length; r++) if (z[r][0].test(t)) return z[r][1];
    return "#d9d9d2";
  }
  function x(e, t, r, i) {
    var s = Number(e);
    isFinite(s) || (s = 0);
    var o = s.toFixed(i).split(".");
    return (
      (o[0] = o[0].replace(/\B(?=(\d{3})+(?!\d))/g, t)),
      i ? o[0] + r + o[1] : o[0]
    );
  }
  function A(e) {
    return (u.moneyFormat || "${{amount}}")
      .replace(
        /\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g,
        x(e, ".", ",", 0),
      )
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, x(e, ".", ",", 2))
      .replace(
        /\{\{\s*amount_no_decimals_with_space_separator\s*\}\}/g,
        x(e, " ", ",", 0),
      )
      .replace(/\{\{\s*amount_with_space_separator\s*\}\}/g, x(e, " ", ",", 2))
      .replace(
        /\{\{\s*amount_with_apostrophe_separator\s*\}\}/g,
        x(e, "'", ".", 2),
      )
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, x(e, ",", ".", 0))
      .replace(/\{\{\s*amount\s*\}\}/g, x(e, ",", ".", 2))
      .replace(/<[^>]*>/g, "")
      .trim();
  }
  function n(e, t, r) {
    var i = document.createElement(e);
    return (t && (i.className = t), r != null && (i.innerHTML = r), i);
  }
  function b(e) {
    return String(e == null ? "" : e).replace(/[&<>"']/g, function (t) {
      return {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;",
      }[t];
    });
  }
  function ae() {
    if (!document.getElementById("rsf-critical")) {
      var e = document.createElement("style");
      ((e.id = "rsf-critical"),
        (e.textContent =
          ".rsf-host > *:not(.rsf-root){display:none!important}.rsf-root{display:grid;grid-template-columns:250px 1fr;align-items:start;gap:34px;max-width:1400px;margin:0 auto;padding:16px 20px 44px}@media(max-width:768px){.rsf-root{grid-template-columns:1fr}}@keyframes rsf-shim{0%{background-position:-400px 0}100%{background-position:400px 0}}.rsf-skel-head,.rsf-skel-row,.rsf-skel-img,.rsf-skel-line{background:#eceef0;background-image:linear-gradient(90deg,#eceef0 0,#f5f6f7 40px,#eceef0 80px);background-size:600px 100%;border-radius:6px;animation:rsf-shim 1.1s linear infinite}.rsf-skel-group{margin-bottom:22px}.rsf-skel-head{height:14px;width:60%;margin-bottom:14px}.rsf-skel-row{height:12px;width:90%;margin:10px 0}.rsf-skel-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:26px 18px}@media(max-width:600px){.rsf-skel-grid{grid-template-columns:repeat(2,1fr)}}.rsf-skel-img{width:100%;aspect-ratio:1/1;border-radius:10px;margin-bottom:10px}.rsf-skel-line{height:12px;width:100%;margin:7px 0}.rsf-skel-line.short{width:55%}"),
        (document.head || document.documentElement).appendChild(e));
    }
  }
  function le() {
    R.innerHTML = "";
    for (var e = "", t = 0; t < 5; t++) {
      e += '<div class="rsf-skel-group"><div class="rsf-skel-head"></div>';
      for (var r = 0; r < 5; r++) e += '<div class="rsf-skel-row"></div>';
      e += "</div>";
    }
    L.innerHTML = e;
    for (var i = "", s = 0; s < 12; s++)
      i +=
        '<div class="rsf-skel-card"><div class="rsf-skel-img"></div><div class="rsf-skel-line"></div><div class="rsf-skel-line short"></div></div>';
    _.innerHTML = '<div class="rsf-skel-grid">' + i + "</div>";
  }
  var N = {
    en: {
      products: "products",
      featured: "Featured",
      priceAsc: "Price: low to high",
      priceDesc: "Price: high to low",
      newest: "Newest",
      filteringBy: "Filtering by",
      allItems: "All items",
      clearAll: "Clear all",
      apply: "Apply",
      soldOut: "Sold out",
      previous: "Previous",
      next: "Next",
      page: "Page",
      of: "of",
      showAll: "Show all",
      showLess: "Show less",
      to: "to",
      filter: "Filter",
      show: "Show",
      hide: "Hide",
      selected: "selected",
    },
    it: {
      products: "prodotti",
      featured: "In evidenza",
      priceAsc: "Prezzo: dal pi\xF9 basso",
      priceDesc: "Prezzo: dal pi\xF9 alto",
      newest: "Pi\xF9 recenti",
      filteringBy: "Filtra per",
      allItems: "Tutti gli articoli",
      clearAll: "Cancella tutto",
      apply: "Applica",
      soldOut: "Esaurito",
      previous: "Precedente",
      next: "Successivo",
      page: "Pagina",
      of: "di",
      showAll: "Mostra tutti",
      showLess: "Mostra meno",
      to: "a",
      filter: "Filtra",
      show: "Mostra",
      hide: "Nascondi",
      selected: "selezionati",
    },
  };
  function p(e) {
    var t = String((window.RamlystSF && window.RamlystSF.locale) || "en")
      .slice(0, 2)
      .toLowerCase();
    return (N[t] && N[t][e]) || N.en[e] || e;
  }
  var l = {
      selections: {},
      page: 1,
      sort: "manual",
      query: null,
      collection: null,
    },
    H = 8,
    P = 4,
    w = [];
  function M(e, t) {
    ((t = Math.max(P, Math.min(t, e.total))), (e.limit = t));
    for (var r = 0; r < e.rows.length; r++)
      e.rows[r].style.display = r < t ? "" : "none";
    t < e.total
      ? ((e.more.textContent = p("showAll") + " " + e.total),
        (e.more.style.display = ""))
      : e.total > H
        ? ((e.more.textContent = p("showLess")), (e.more.style.display = ""))
        : (e.more.style.display = "none");
  }
  function G() {
    if (!(!_ || !L || !w.length)) {
      for (var e = 0; e < w.length; e++) M(w[e], H);
      if (!(
        window.matchMedia && window.matchMedia("(max-width: 768px)").matches
      )) {
        var t = _.offsetHeight;
        if (t) {
          var r = L.querySelector(".rsf-value-label"),
            i = (r && r.offsetHeight) || 30,
            s = Math.round((t - L.offsetHeight) / i);
          if (s > 0)
            for (var o = 0; o < w.length && s > 0; o++) {
              var a = w[o];
              if (a.limit < a.total) {
                var d = Math.min(a.total - a.limit, s);
                (M(a, a.limit + d), (s -= d));
              }
            }
          else if (s < 0)
            for (var f = -s, c = 0; c < w.length && f > 0; c++) {
              var v = w[c];
              if (v.limit > P) {
                var g = Math.min(v.limit - P, f);
                (M(v, v.limit - g), (f -= g));
              }
            }
        }
      }
    }
  }
  function se() {
    var e = new URLSearchParams();
    return (
      Object.keys(l.selections).forEach(function (t) {
        var r = l.selections[t];
        r && r.length && e.set(t, r.join(","));
      }),
      l.page > 1 && e.set("page", String(l.page)),
      l.sort && l.sort !== "manual" && e.set("sort", l.sort),
      l.query && e.set("q", l.query),
      // Search page, first load, nothing chosen yet: let the backend understand the sentence (nl=1).
      l.query &&
        !l.__nl &&
        !Object.keys(l.selections).length &&
        e.set("nl", "1"),
      l.collection && e.set("collection", l.collection),
      e.set("limit", "42"),
      e
    );
  }
  // ---- Shareable filter URLs (John 2026-10-23) -------------------------------------------
  // Mirror the active selection (l.selections) into the browser address bar so a copied
  // collection link reproduces the EXACT filter selection for a customer, and apply a shared
  // link's selection on load. Same param names the backend uses; collection/limit are internal.
  var RSF_RES = { page: 1, sort: 1, q: 1, collection: 1, limit: 1 };
  function rsfWriteUrl() {
    try {
      // Start from the CURRENT url so foreign params (utm, gclid, ...) survive; drop only our own
      // previous state, then write the live selection. Only pf_* keys are ever written as filters.
      var e = new URLSearchParams(window.location.search);
      var drop = [];
      e.forEach(function (v, k) {
        if (/^pf_/.test(k) || k === "page" || k === "sort" || k === "q")
          drop.push(k);
      });
      drop.forEach(function (k) {
        e.delete(k);
      });
      Object.keys(l.selections).forEach(function (t) {
        var r = l.selections[t];
        r && r.length && /^pf_/.test(t) && e.set(t, r.join(","));
      });
      l.page > 1 && e.set("page", String(l.page));
      l.sort && l.sort !== "manual" && e.set("sort", l.sort);
      (l.nlq || l.query) && e.set("q", l.nlq || l.query); // the shopper's own sentence stays in the link
      var q = e.toString();
      window.history.replaceState(
        null,
        "",
        window.location.pathname + (q ? "?" + q : "") + window.location.hash,
      );
    } catch (x) {}
  }
  // ---- Natural-language search (John's Search Plan 10-26, steps 2/5/7) ----------------------
  // The backend answers a sentence with nl:{applied:[{param,value,label}], keywords, relaxed}.
  // We adopt those as ordinary selections (so chips, checkboxes and the URL all agree) and
  // re-fetch once; the shopper sees clean words ("Ovale", "Oro bianco"), never a tag string.
  var RSF_NLS =
    String(u.locale || "")
      .toLowerCase()
      .indexOf("it") === 0
      ? {
          products: "Prodotti",
          viewAll: "Vedi tutti i {n} risultati",
          none: "Nessun risultato per",
          resultsFor: "Risultati per",
          relaxed: "Nessuna corrispondenza esatta — mostrati senza:",
          upTo: "fino a",
          from: "da",
        }
      : {
          products: "Products",
          viewAll: "View all {n} results",
          none: "No results for",
          resultsFor: "Results for",
          relaxed: "No exact match — showing without:",
          upTo: "up to",
          from: "from",
        };
  // A price selection is stored as "min:max"; the chip must read as money ("fino a €5.000"), never ":5000".
  function rsfChipLabel(param, s) {
    if (param !== "pf_p_price") return s;
    var m = String(s).split(":"),
      lo = parseFloat(m[0]),
      hi = parseFloat(m[1]);
    if (lo > 0 && hi > 0) return A(lo) + " – " + A(hi);
    if (hi > 0) return RSF_NLS.upTo + " " + A(hi);
    if (lo > 0) return RSF_NLS.from + " " + A(lo);
    return s;
  }
  function rsfAdoptNl(nl) {
    var changed = false;
    (nl.applied || []).forEach(function (a) {
      var cur = l.selections[a.param] || [];
      if (cur.indexOf(a.value) === -1) {
        l.selections[a.param] = cur.concat([a.value]);
        changed = true;
      }
    });
    if (nl.price && (nl.price.min || nl.price.max)) {
      l.selections.pf_p_price = [
        (nl.price.min || "") + ":" + (nl.price.max || ""),
      ];
      changed = true;
    }
    l.__nl = 1;
    l.nlq = l.query;
    l.nlRelaxed = nl.relaxed || [];
    if (changed || (nl.keywords || "") !== l.query) {
      l.query = nl.keywords || "";
      return true;
    }
    return false;
  }
  function rsfNlNote(host) {
    if (!host || !l.nlq) return;
    var note = host.querySelector(".rsf-nl-note");
    if (!note) {
      note = document.createElement("div");
      note.className = "rsf-nl-note";
      host.insertBefore(note, host.firstChild);
    }
    var txt = RSF_NLS.resultsFor + " “" + l.nlq + "”";
    if (l.nlRelaxed && l.nlRelaxed.length)
      txt += " · " + RSF_NLS.relaxed + " " + l.nlRelaxed.join(", ");
    note.textContent = txt;
  }
  function rsfReadUrl() {
    try {
      new URLSearchParams(window.location.search).forEach(function (v, key) {
        if (key === "page") {
          var n = parseInt(v, 10);
          n > 0 && (l.page = n);
          return;
        }
        if (key === "sort") {
          v && (l.sort = v);
          return;
        }
        if (RSF_RES[key] || !/^pf_/.test(key)) return; // only OUR filter params; never a tracking/session id
        v &&
          (l.selections[key] = v
            .split(",")
            .map(function (s) {
              return s.trim();
            })
            .filter(Boolean));
      });
    } catch (x) {}
  }
  function B(e, t) {
    t = t || 0;
    var r = new AbortController(),
      i = setTimeout(function () {
        r.abort();
      }, 2e4);
    return fetch(e, {
      headers: { Accept: "application/json" },
      signal: r.signal,
    })
      .then(function (s) {
        if ((clearTimeout(i), !s.ok))
          throw new Error("request failed: " + s.status);
        return s.json();
      })
      .catch(function (s) {
        if ((clearTimeout(i), t < 2)) return B(e, t + 1);
        throw s;
      });
  }
  function V(e, t) {
    return u.apiBase && u.shop
      ? u.apiBase +
          "/api/public/" +
          e +
          "?shop=" +
          encodeURIComponent(u.shop) +
          (t ? "&" + t : "")
      : u.proxyUrl + "/" + e + (t ? "?" + t : "");
  }
  function oe() {
    var e = se().toString(),
      t =
        u.__prefetch ||
        (typeof window != "undefined" ? window.__RSF_PREFETCH : null);
    if (t && t.key === e && t.promise) {
      u.__prefetch = null;
      try {
        window.__RSF_PREFETCH = null;
      } catch (r) {}
      return t.promise;
    }
    return B(V("filter", e));
  }
  function X(e, t) {
    var r = l.selections[e] || [],
      i = r.indexOf(t);
    ((l.selections[e] =
      i === -1
        ? r.concat([t])
        : r.filter(function (s) {
            return s !== t;
          })),
      (l.page = 1),
      k());
  }
  function ce() {
    ((l.selections = {}), (l.page = 1), k());
  }
  function de(e) {
    e.innerHTML = "";
    var t = Object.keys(l.selections).some(function (i) {
      return (l.selections[i] || []).length;
    });
    if (
      (e.appendChild(
        n("span", "rsf-active-label", p(t ? "filteringBy" : "allItems")),
      ),
      Object.keys(l.selections).forEach(function (i) {
        (l.selections[i] || []).forEach(function (s) {
          var o = n(
            "button",
            "rsf-tag",
            b(rsfChipLabel(i, s)) + ' <span aria-hidden="true">\u2715</span>',
          );
          ((o.type = "button"),
            o.addEventListener("click", function () {
              X(i, s);
            }),
            e.appendChild(o));
        });
      }),
      t)
    ) {
      var r = n("button", "rsf-clear", p("clearAll"));
      ((r.type = "button"), r.addEventListener("click", ce), e.appendChild(r));
    }
  }
  function fe(e, t) {
    ((e.innerHTML = ""),
      (w = []),
      t.forEach(function (r) {
        if (!(r.filterType !== "price" && (!r.values || !r.values.length))) {
          var i = n("div", "rsf-group"),
            s = n(
              "button",
              "rsf-group-header",
              "<span>" +
                b(r.label) +
                '</span><span class="rsf-caret">\u25BE</span>',
            );
          ((s.type = "button"),
            s.addEventListener("click", function () {
              i.classList.toggle("rsf-collapsed");
            }));
          var o = n("div", "rsf-group-body");
          if (r.filterType === "price") {
            var a = n("div", "rsf-price-row"),
              d = n("input", "rsf-price-input");
            ((d.type = "number"), (d.placeholder = String(r.min || 0)));
            var f = n("input", "rsf-price-input");
            ((f.type = "number"), (f.placeholder = String(r.max || 0)));
            var c = l.selections[r.param];
            if (c && c[0]) {
              var v = c[0].split(":");
              (v[0] && (d.value = v[0]), v[1] && (f.value = v[1]));
            }
            var g = n("button", "rsf-price-apply", p("apply"));
            ((g.type = "button"),
              g.addEventListener("click", function () {
                var m = (d.value || "") + ":" + (f.value || "");
                ((l.selections[r.param] = m === ":" ? [] : [m]),
                  (l.page = 1),
                  k());
              }),
              a.appendChild(d),
              a.appendChild(n("span", "rsf-price-dash", p("to"))),
              a.appendChild(f),
              a.appendChild(g),
              o.appendChild(a));
          } else {
            var I = l.selections[r.param] || [],
              y = r.label.toLowerCase(),
              F = /colou?r|colore|couleur|farbe|kleur/.test(y),
              U = /metal|m[e\u00e9]tal|metaal/.test(y),
              q = n("ul", "rsf-values");
            if (
              (r.values.forEach(function (m) {
                var te = n("li", "rsf-value"),
                  T = n(
                    "label",
                    "rsf-value-label" +
                      (I.indexOf(m.label) !== -1 ? " rsf-on" : ""),
                  );
                if ((T.appendChild(n("span", "rsf-box")), F || U)) {
                  var re = n("span", "rsf-dot");
                  ((re.style.background = F ? ie(m.label) : ne(m.label)),
                    T.appendChild(re));
                }
                (T.appendChild(n("span", "rsf-value-text", b(m.label))),
                  T.appendChild(n("span", "rsf-value-count", String(m.count))),
                  T.addEventListener("click", function (be) {
                    (be.preventDefault(), X(r.param, m.label));
                  }),
                  te.appendChild(T),
                  q.appendChild(te));
              }),
              o.appendChild(q),
              r.values.length > P)
            ) {
              var O = n("button", "rsf-show-more");
              O.type = "button";
              var D = {
                list: q,
                rows: [].slice.call(q.children),
                total: r.values.length,
                more: O,
                limit: r.values.length,
              };
              (O.addEventListener(
                "click",
                (function (m) {
                  return function () {
                    M(m, m.limit < m.total ? m.total : H);
                  };
                })(D),
              ),
                o.appendChild(O),
                M(D, H),
                w.push(D));
            }
          }
          (i.appendChild(s), i.appendChild(o), e.appendChild(i));
        }
      }));
  }
  function ue(e, t) {
    e.innerHTML = "";
    var r = n("div", "rsf-toolbar");
    r.appendChild(
      n(
        "span",
        "rsf-meta",
        t.total_product.toLocaleString() + " " + p("products"),
      ),
    );
    var i = n("select", "rsf-sort");
    ([
      ["manual", p("featured")],
      ["price-ascending", p("priceAsc")],
      ["price-descending", p("priceDesc")],
      ["created-descending", p("newest")],
    ].forEach(function (c) {
      var v = n("option", null, c[1]);
      ((v.value = c[0]),
        l.sort === c[0] && (v.selected = !0),
        i.appendChild(v));
    }),
      i.addEventListener("change", function () {
        ((l.sort = i.value), (l.page = 1), k());
      }),
      r.appendChild(i),
      e.appendChild(r));
    var s = n("div", "rsf-grid");
    (t.products.forEach(function (c, v) {
      var g = n("a", "rsf-card");
      g.href = c.url;
      var I = n("div", "rsf-card-img");
      if (c.image) {
        var y = n("img"),
          F = v < 3;
        ((y.loading = F ? "eager" : "lazy"),
          (y.decoding = "async"),
          F && y.setAttribute("fetchpriority", "high"),
          (y.width = 400),
          (y.height = 400),
          (y.src = c.image),
          (y.alt = c.image_alt || c.title),
          I.appendChild(y));
      }
      (g.appendChild(I), g.appendChild(n("div", "rsf-card-title", b(c.title))));
      var U =
        c.price_min === c.price_max
          ? A(c.price_min)
          : A(c.price_min) + " \u2013 " + A(c.price_max);
      (g.appendChild(n("div", "rsf-card-price", b(U))),
        c.available ||
          g.appendChild(n("div", "rsf-card-soldout", p("soldOut"))),
        s.appendChild(g));
    }),
      e.appendChild(s));
    var o = Math.max(Math.ceil(t.total_product / t.per_page), 1);
    if (o > 1) {
      var a = n("div", "rsf-pager"),
        d = n("button", "rsf-page-btn", p("previous"));
      ((d.type = "button"),
        (d.disabled = l.page <= 1),
        d.addEventListener("click", function () {
          (l.page--, k(!0));
        }));
      var f = n("button", "rsf-page-btn", p("next"));
      ((f.type = "button"),
        (f.disabled = l.page >= o),
        f.addEventListener("click", function () {
          (l.page++, k(!0));
        }),
        a.appendChild(d),
        a.appendChild(
          n(
            "span",
            "rsf-page-info",
            p("page") + " " + l.page + " " + p("of") + " " + o,
          ),
        ),
        a.appendChild(f),
        e.appendChild(a));
    }
  }
  var h,
    R,
    L,
    _,
    C,
    S = !1,
    E = !1;
  function W() {
    S ||
      !C ||
      (C === document.body || C.classList.add("rsf-host"),
      C.appendChild(h),
      he(),
      (S = !0));
  }
  // 2026-11-04: when the engine gives up (fetch failed / 20 s timeout), reveal the pure-Liquid
  // fallback filters rendered by snippets/ramlyst-fallback.liquid, placed above the native grid.
  function rsfFallback() {
    try {
      var f = document.getElementById("rsf-fallback");
      if (!f) return;
      var g = Y(!0) || document.querySelector("main");
      if (g) {
        var sec = g.closest(".shopify-section") || g;
        if (sec.parentNode && f.parentNode !== sec.parentNode) sec.parentNode.insertBefore(f, sec);
      }
      f.hidden = !1;
      document.documentElement.classList.add("rsf-fallback");
    } catch (e) {}
  }
  window.rsfFallback = rsfFallback;
  function J() {
    S &&
      (C && C !== document.body && C.classList.remove("rsf-host"),
      h && h.parentNode && h.parentNode.removeChild(h),
      (S = !1));
    rsfFallback();
  }
  function k(e) {
    S && E && h.classList.add("rsf-loading");
    var t = null;
    (E ||
      (t = setTimeout(function () {
        E || J();
      }, 2e4)), // 20 s, was 6 s: a slow first answer must not leave the shopper a blank page (John 10/27)
      oe()
        .then(function (r) {
          if (r && r.nl && !l.__nl && rsfAdoptNl(r.nl)) {
            t && clearTimeout(t);
            return k(e);
          }
          (t && clearTimeout(t),
            (E = !0),
            h.classList.remove("rsf-skeleton"),
            de(R),
            l.__nl && rsfNlNote(R),
            fe(L, (r.filter && r.filter.options) || []),
            ue(_, r),
            rsfWriteUrl(),
            W(),
            G(),
            h.classList.remove("rsf-loading"),
            e && h.scrollIntoView({ behavior: "smooth", block: "start" }));
        })
        .catch(function (r) {
          (t && clearTimeout(t),
            h.classList.remove("rsf-loading"),
            console.error("[RamlystSF]", r),
            E || J());
        }));
  }
  function Y(e) {
    for (
      var t = [
          "#product-grid",
          ".collection-grid",
          ".collection .grid",
          "#CollectionProductGrid",
          "#main-collection-product-grid",
        ],
        r = 0;
      r < t.length;
      r++
    ) {
      var i = document.querySelector(t[r]);
      if (i) return i;
    }
    return e
      ? null
      : document.querySelector(".collection") ||
          document.querySelector("main") ||
          null;
  }
  function pe(e) {
    ((C = e || Y() || document.querySelector("main") || document.body),
      (S = !1),
      (E = !1),
      ae(),
      (h = n("div", "rsf-root rsf-skeleton")),
      (R = n("div", "rsf-active")),
      (L = n("aside", "rsf-filters")),
      (_ = n("div", "rsf-products")),
      h.appendChild(R),
      h.appendChild(L),
      h.appendChild(_),
      le(),
      W(),
      k());
  }
  function he() {
    [
      "nav.pagination",
      ".pagination-wrapper",
      ".pagination",
      ".collection-pagination",
      ".pagination__list",
      ".product-count",
      "#ProductCountDesktop",
    ].forEach(function (e) {
      document.querySelectorAll(e).forEach(function (t) {
        h && !h.contains(t) && (t.style.display = "none");
      });
    });
  }
  function ve() {
    var e = document.querySelectorAll('input[type="search"], input[name="q"]');
    if (!e.length) return;
    var t = n("div", "rsf-search-dropdown");
    ((t.style.display = "none"), document.body.appendChild(t));
    var r = null,
      i = null;
    function s() {
      if (i) {
        var a = i.getBoundingClientRect();
        ((t.style.top = a.bottom + window.scrollY + 4 + "px"),
          (t.style.left = a.left + window.scrollX + "px"),
          (t.style.width = Math.max(a.width, 320) + "px"));
      }
    }
    function o(a) {
      B(V("search", "q=" + encodeURIComponent(a) + "&limit=8"))
        .then(function (d) {
          (!d.products || !d.products.length
            ? (t.innerHTML =
                '<div class="rsf-search-empty">' +
                RSF_NLS.none +
                " \u201C" +
                b(a) +
                "\u201D</div>")
            : (t.innerHTML =
                '<div class="rsf-search-heading">' +
                RSF_NLS.products +
                "</div>" +
                d.products
                  .map(function (f) {
                    return (
                      '<a class="rsf-search-item" href="' +
                      b(f.url) +
                      '">' +
                      (f.image
                        ? '<img class="rsf-search-thumb" loading="lazy" decoding="async" width="56" height="56" src="' +
                          b(f.image) +
                          '" alt="">'
                        : '<span class="rsf-search-thumb"></span>') +
                      '<span class="rsf-search-text"><span class="rsf-search-title">' +
                      b(f.title) +
                      '</span><span class="rsf-search-price">' +
                      b(A(f.price_min)) +
                      "</span></span></a>"
                    );
                  })
                  .join("") +
                '<a class="rsf-search-all" href="/search?q=' +
                encodeURIComponent(a) +
                '">' +
                b(RSF_NLS.viewAll.replace("{n}", String(d.total))) +
                "</a>"),
            s(),
            (t.style.display = "block"));
        })
        .catch(function () {
          t.style.display = "none";
        });
    }
    (e.forEach(function (a) {
      (a.setAttribute("autocomplete", "off"),
        a.addEventListener("input", function () {
          ((i = a), clearTimeout(r));
          var d = a.value.trim();
          if (d.length < 2) {
            t.style.display = "none";
            return;
          }
          r = setTimeout(function () {
            o(d);
          }, 180);
        }),
        a.addEventListener("focus", function () {
          i = a;
        }));
    }),
      document.addEventListener("click", function (a) {
        !t.contains(a.target) && a.target !== i && (t.style.display = "none");
      }),
      window.addEventListener("resize", s));
  }
  function me() {
    var e = String(u.collectionHandle || "").toLowerCase();
    return !e || e === "all" || e === "frontpage";
  }
  function $() {
    return u.isCollection && u.collectionFilters
      ? !0
      : u.isSearch
        ? !!new URLSearchParams(window.location.search).get("q")
        : !1;
  }
  var K = !1;
  function Q(e) {
    if (K || !$()) return !0;
    var t = Y(e);
    return t
      ? ((K = !0),
        u.isSearch &&
          (l.query =
            new URLSearchParams(window.location.search).get("q") || null),
        u.isCollection &&
          u.collectionFilters &&
          (l.collection = me() ? null : String(u.collectionHandle)),
        rsfReadUrl(),
        pe(t),
        !0)
      : !1;
  }
  function Z() {
    (Q(!1), u.instantSearch && ve());
  }
  var ee;
  if (
    (window.addEventListener("resize", function () {
      (clearTimeout(ee),
        (ee = setTimeout(function () {
          w.length && G();
        }, 200)));
    }),
    $())
  ) {
    var ge = 0;
    (function e() {
      Q(!0) || ++ge > 600 || requestAnimationFrame(e);
    })();
  }
  document.readyState === "loading"
    ? document.addEventListener("DOMContentLoaded", Z)
    : Z();
})();
